import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import type { FileTypePaginatedRequest } from 'types'

import { fileTypeGet, fileTypeList } from './file-type.service'

export const fileTypeKeyFactory = {
  base: () => ['file-types'],
  list: (request?: FileTypePaginatedRequest) => [
    ...fileTypeKeyFactory.base(),
    'list',
    ...(request ? [request] : []),
  ],
  get: (uuid: string) => [...fileTypeKeyFactory.base(), 'get', uuid],
}

export const queryFileTypeList = (request: FileTypePaginatedRequest) =>
  queryOptions({
    queryKey: fileTypeKeyFactory.list(request),
    queryFn: () => fileTypeList(request),
    placeholderData: keepPreviousData,
  })

export const queryFileTypeGet = (uuid: string) =>
  queryOptions({
    queryKey: fileTypeKeyFactory.get(uuid),
    queryFn: () => fileTypeGet(uuid),
  })
